$(document).ready(function () {
  function updateVisibility() {
      var checkedItems = $(".pests-item-wrapper .pest-items .pest-label input:checked").map(function () {
          return $(this).closest(".pest-label").data("id");
      }).get();

      if (checkedItems.length > 0) {
          $(".pest-lists .pest-items").hide();
          checkedItems.forEach(function (id) {
              $("#" + id).show();
          });
      } else {
          $(".pest-lists .pest-items").show();
      }
  }
  $(".pests-item-wrapper .pest-items .pest-label input").on("change", function () {
      updateVisibility();
  });
  $('.common-popup-container .popup-close-wrapper .popup-close').click(function(){
    $('body').removeClass('body-fixed');
    $('.pest-species-popup.custom-modal-popup').removeClass('open');
  });
  $('.custom-popup-show, a[href="#bug-popup"]').click(function(e){
    e.preventDefault();
    $('body').addClass('body-fixed');
    $('.pest-species-popup.custom-modal-popup').addClass('open');
  });
});
